import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/haze.vue
var o = {
	name: "DtIconHaze",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--haze"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Haze",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M2.246 2.746a.5.5 0 0 1 .708 0l.7.7a.5.5 0 1 1-.708.708l-.7-.7a.5.5 0 0 1 0-.708ZM.5 6.5A.5.5 0 0 1 1 6h1a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm9 0A.5.5 0 0 1 10 6h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm.254-3.754a.5.5 0 0 1 0 .708l-.7.7a.5.5 0 1 1-.708-.708l.7-.7a.5.5 0 0 1 .708 0ZM.5 8.5A.5.5 0 0 1 1 8h10a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm0 2A.5.5 0 0 1 1 10h10a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm3.732-5.768A2.5 2.5 0 0 1 8.5 6.5a.5.5 0 0 1-1 0 1.5 1.5 0 0 0-3 0 .5.5 0 0 1-1 0 2.5 2.5 0 0 1 .732-1.768ZM6 .75a.5.5 0 0 1 .5.5V2.5a.5.5 0 0 1-1 0V1.25a.5.5 0 0 1 .5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=haze.js.map